import React from 'react'

export default function AttendanceBottomBar({
  totalCount = 0,
  date = '',
  presentCount = 0,
  presentPct = 0,
  absentCount = 0,
  absentPct = 0,
  holidayCount = 0,
  holidayPct: holidayPctProp,
  onSave,
  isSaving = false,
  className = '',
}) {
  const holidayPct =
    holidayPctProp !== undefined
      ? holidayPctProp
      : totalCount > 0
      ? Math.round((holidayCount / totalCount) * 100)
      : 0

  return (
    <div
      className={`fixed bottom-0 left-0 lg:left-64 right-0 z-30 border-t border-outline-variant/20 bg-surface-container-lowest/95 backdrop-blur-md px-6 py-3.5 shadow-lg ${className}`}
    >
      <div className="mx-auto flex max-w-[1460px] items-center justify-between gap-4">
        {/* Left Status Breakdown */}
        <div className="flex flex-wrap items-center gap-3 min-w-0">
          <span className="text-xs font-bold text-on-surface-variant">
            Showing <span className="font-extrabold text-on-surface">{totalCount}</span> students for{' '}
            <span className="font-extrabold text-primary">{date}</span>
          </span>

          <div className="hidden sm:flex items-center gap-2">
            <span className="inline-flex items-center gap-1 rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-2.5 py-1 text-xs font-bold text-emerald-700">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
              <span>{presentCount} Present ({presentPct}%)</span>
            </span>

            <span className="inline-flex items-center gap-1 rounded-xl border border-rose-500/30 bg-rose-500/10 px-2.5 py-1 text-xs font-bold text-rose-700">
              <span className="h-1.5 w-1.5 rounded-full bg-rose-500" />
              <span>{absentCount} Absent ({absentPct}%)</span>
            </span>

            <span className="inline-flex items-center gap-1 rounded-xl border border-indigo-500/30 bg-indigo-500/10 px-2.5 py-1 text-xs font-bold text-indigo-700">
              <span className="h-1.5 w-1.5 rounded-full bg-indigo-500" />
              <span>{holidayCount} Holiday ({holidayPct}%)</span>
            </span>
          </div>
        </div>

        {/* Right Save Action */}
        <div className="shrink-0">
          <button
            type="button"
            disabled={isSaving || totalCount === 0}
            onClick={onSave}
            className="flex items-center gap-2 rounded-2xl bg-primary px-8 py-2.5 text-xs font-extrabold text-on-primary shadow-md hover:bg-primary/90 transition cursor-pointer disabled:opacity-50"
          >
            <span className="material-symbols-outlined text-base">
              {isSaving ? 'progress_activity' : 'save'}
            </span>
            <span>{isSaving ? 'Saving Attendance...' : 'Save Attendance'}</span>
          </button>
        </div>
      </div>
    </div>
  )
}
